if (!customElements.get('bundle-upsell')) {
  customElements.define('bundle-upsell', class BundleUpsell extends HTMLElement {
    constructor() {
      super();
      this.items = this.querySelectorAll('.bundle-upsell__option');
      this.radios = this.querySelectorAll('input[name="bundle-select"]');
      this.addBtn = this.querySelector('.bundle-upsell__add-btn');
      this.totalPriceEl = this.querySelector('[data-bundle-total]');
      this.savingsEl = this.querySelector('[data-bundle-savings]');
      this.savingsPctEl = this.querySelector('[data-bundle-savings-pct]');
      this.bundlePrice = parseInt(this.dataset.bundlePrice, 10);
      this.currentVariantInput = this.querySelector('[data-current-variant-input]');

      this.radios.forEach(radio => {
        radio.addEventListener('change', this.onSelectionChange.bind(this));
      });

      // Listen for variant selector changes within bundle option items
      this.querySelectorAll('.bundle-upsell__option .bundle-upsell__variant-select select').forEach(select => {
        select.addEventListener('change', this.onVariantChange.bind(this));
      });

      // Listen for current product variant changes
      if (this.currentVariantInput && this.currentVariantInput.tagName === 'SELECT') {
        this.currentVariantInput.addEventListener('change', this.onCurrentVariantChange.bind(this));
      }

      if (this.addBtn) {
        this.addBtn.addEventListener('click', this.onAddToCart.bind(this));
      }

      this.updateUI();
    }

    onSelectionChange() {
      this.updateUI();
    }

    onCurrentVariantChange(evt) {
      const select = evt.target;
      const selectedOption = select.options[select.selectedIndex];
      const currentItem = this.querySelector('[data-bundle-current]');

      // Update image
      const imgSrc = selectedOption.dataset.variantImgSrc;
      if (imgSrc) {
        const img = currentItem.querySelector('.bundle-upsell__image');
        if (img) img.src = imgSrc;
      }

      // Update price display
      const priceEl = currentItem.querySelector('.bundle-upsell__price');
      if (priceEl) {
        const priceData = selectedOption.dataset.price;
        if (priceData) priceEl.textContent = priceData;
      }

      this.updateUI();
    }

    onVariantChange(evt) {
      const select = evt.target;
      const item = select.closest('.bundle-upsell__option');
      if (!item) return;
      const radio = item.querySelector('input[name="bundle-select"]');

      // Auto-select this item when variant changes
      if (radio && !radio.checked) {
        radio.checked = true;
      }

      // Update image if variant has a featured image
      const selectedOption = select.options[select.selectedIndex];
      const imgSrc = selectedOption.dataset.variantImgSrc;
      if (imgSrc) {
        const img = item.querySelector('.bundle-upsell__image');
        if (img) img.src = imgSrc;
      }

      // Update price display
      const priceEl = item.querySelector('.bundle-upsell__price');
      if (priceEl) {
        const priceData = selectedOption.dataset.price;
        if (priceData) priceEl.textContent = priceData;
      }

      this.updateUI();
    }

    getSelectedItem() {
      const checked = this.querySelector('input[name="bundle-select"]:checked');
      return checked ? checked.closest('.bundle-upsell__option') : null;
    }

    getCurrentPrice() {
      if (this.currentVariantInput && this.currentVariantInput.tagName === 'SELECT') {
        return parseInt(this.currentVariantInput.options[this.currentVariantInput.selectedIndex].dataset.priceRaw, 10) || 0;
      }
      if (this.currentVariantInput) {
        return parseInt(this.currentVariantInput.dataset.price, 10) || 0;
      }
      return parseInt(this.dataset.currentPrice, 10) || 0;
    }

    getCurrentVariantId() {
      if (this.currentVariantInput) {
        return this.currentVariantInput.value;
      }
      return this.dataset.currentVariantId;
    }

    updateUI() {
      // Update selected styling
      this.items.forEach(item => {
        const radio = item.querySelector('input[name="bundle-select"]');
        item.classList.toggle('bundle-upsell__option--selected', radio && radio.checked);
      });

      const selected = this.getSelectedItem();
      if (selected) {
        // Calculate savings
        const currentPrice = this.getCurrentPrice();
        const selectedVariantSelect = selected.querySelector('.bundle-upsell__variant-select select');
        const selectedHiddenInput = selected.querySelector('input[type="hidden"][data-price]');
        let selectedPrice = 0;
        if (selectedVariantSelect) {
          selectedPrice = parseInt(selectedVariantSelect.options[selectedVariantSelect.selectedIndex].dataset.priceRaw, 10) || 0;
        } else if (selectedHiddenInput) {
          selectedPrice = parseInt(selectedHiddenInput.dataset.price, 10) || 0;
        }
        const regularTotal = currentPrice + selectedPrice;
        const savings = regularTotal - this.bundlePrice;

        if (this.savingsEl && savings > 0) {
          const savingsPct = Math.round((savings / regularTotal) * 100);
          this.savingsEl.textContent = this.formatMoney(savings);
          if (this.savingsPctEl) this.savingsPctEl.textContent = '-' + savingsPct + '%!';
          this.savingsEl.closest('.bundle-upsell__total-savings').hidden = false;
        } else if (this.savingsEl) {
          this.savingsEl.closest('.bundle-upsell__total-savings').hidden = true;
        }

        this.addBtn.disabled = false;
      } else {
        this.addBtn.disabled = true;
        if (this.savingsEl) {
          this.savingsEl.closest('.bundle-upsell__total-savings').hidden = true;
        }
      }
    }

    formatMoney(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + '\u00A0€';
    }

    async onAddToCart(evt) {
      evt.preventDefault();
      const selected = this.getSelectedItem();
      if (!selected) return;

      this.addBtn.classList.add('loading');
      this.addBtn.disabled = true;

      // Get current product variant ID
      const currentId = this.getCurrentVariantId();

      // Get selected bundle product variant ID
      const variantSelect = selected.querySelector('.bundle-upsell__variant-select select');
      const hiddenInput = selected.querySelector('input[type="hidden"][data-variant-id]');
      const selectedVariantId = variantSelect
        ? variantSelect.value
        : (hiddenInput ? hiddenInput.value : null);

      if (!selectedVariantId || !currentId) {
        this.addBtn.classList.remove('loading');
        this.addBtn.disabled = false;
        return;
      }

      const items = [
        { id: parseInt(currentId, 10), quantity: 1 },
        { id: parseInt(selectedVariantId, 10), quantity: 1 }
      ];

      const cartAddUrl = (typeof routes !== 'undefined' && routes.cart_add_url)
        ? routes.cart_add_url + '.js'
        : '/cart/add.js';

      try {
        const res = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: items })
        });

        const json = await res.json();
        if (res.status !== 200) throw new Error(json.description);

        // Trigger cart update event (opens drawer cart or updates cart count)
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: json }));

        // Also trigger cart:update for drawer cart refresh
        document.dispatchEvent(new CustomEvent('cart:update', { detail: json }));

      } catch (err) {
        console.error('Bundle add to cart error:', err);
      } finally {
        this.addBtn.classList.remove('loading');
        this.addBtn.disabled = false;
      }
    }
  });
}
